let swiper = require('./swiper').default;

/**
 * Обработка вкладок с заведениями на главной странице
 */
class BestPlaces
{
    constructor(selector = '.best-places', isLazySwiper = false) {
        this.maps = [];
        this.isLazySwiper = isLazySwiper;
        this.mapTumbler = document.querySelector(selector + ' .best-places__tumbler-input');
        this.mapContainer = document.querySelector(selector + ' .best-places__in-map');
        this.tabs = $(selector + ' .tab').simpleTabs(tab => this.showBars(tab));

        this.initTabsOfSwiper(selector);

        new YandexMap(this.mapContainer, $app.cityCoords, $app.ymapApiKey).then(Map => {
            Map.setAutoLocation(isLazySwiper).then(result => {
                this.Map = Map;
                this.coords = this.getAndSetCoords(result);
                this.mapTumbler.addEventListener('change', () => this.processTumbler());

                if (!isLazySwiper) {
                    this.mapTumbler.parentNode.classList.remove('d-none');
                }
            });
        });
    }

    processTumbler() {
        this.mapContainer.style.display = this.mapTumbler.checked ? 'block' : 'none';
        this.mapContainer.nextElementSibling.style.display = this.mapTumbler.checked ? 'none' : 'block';

        this.showBars(this.tabs.filter('.tabs__item--active'));

        if ($app.isMobile) {
            $app.scrollTo(this.tabs.closest('.best-places__nav'));
        }

        $app.runEvent('click', { [this.mapTumbler.parentNode.dataset.event]: this.mapTumbler.checked ? 'Карта' : 'Список' });
    }

    showBars($tab) {
        if (this.mapTumbler.checked) {
            if (this.maps && this.maps[$tab.data('id')]) {
                $filter.mapHelper.setPlacemarks(this.Map, this.maps[$tab.data('id')]);
                this.updateZoom();
            } else {
                $filter.mapHelper.loadBarsForMap(this.Map, { homepageTab: $tab.data('id'), coords: this.coords }).then(({ barList }) => {
                    this.updateZoom();
                    this.maps[$tab.data('id')] = barList;
                });
            }
        } else if (!$tab.data('content')[0].swiper.slides.length) {
            this.loadBarsForTab($tab.data('content')[0].swiper);
        }

        if (this.mapTumbler.parentNode.classList.contains('d-none')) {
            this.mapTumbler.parentNode.classList.remove('d-none');
        }
    }

    initTabsOfSwiper(selector) {
        swiper(selector + ' .best-places__slider', {
            breakpoints: {
                0: {
                    slidesPerView: 'auto'
                },
                576: {
                    slidesPerView: 'auto',
                },
                768: {
                    slidesPerView: 2
                },
                992: {
                    slidesPerView: 3
                },
                1200: {
                    slidesPerView: 4
                }
            },
            pagination: {},
            on: {
                reachEnd: s => {
                    if (this.isLazySwiper) {
                        this.isLazySwiper = false;
                    } else {
                        this.loadBarsForTab(s);
                    }
                }
            }
        });
    }

    loadBarsForTab(swiper) {
        let coords = this.coords,
            slides = Object.values(swiper.slides),
            tabId = this.tabs.filter('.tabs__item--active').data('id');

        let loadedIds = slides.map(item => item.dataset.id);

        return $.get($app.urlPrefix + '/tab', { coords, loadedIds, tabId }, ({ slides }) => {
            if (slides && slides.trim()) {
                let s = $(slides);

                if (swiper.wrapperEl.textContent === 'Заведений не найдено :(') {
                    swiper.wrapperEl.textContent = '';
                }

                swiper.appendSlide(s);

                $helpers.initTooltips(s);
            } else if (!swiper.slides.length) {
                swiper.wrapperEl.textContent = 'Заведений не найдено :(';
            }
        });
    }

    updateZoom() {
        if ($app.isMobile) {
            this.Map.setAutoLocation().then(result => {
                setTimeout(() => {
                    this.Map.map.setCenter(this.getAndSetCoords(result));
                    this.Map.map.setZoom(17);
                }, 1000);
            });
        }
    }

    getAndSetCoords(result) {
        return this.coords = result.geoObjects.get(0).geometry.getCoordinates();
    }
}

module.exports = BestPlaces;